import type { Mark } from '../document-types';
import type { MarkHandler } from './types';

export class ItalicMark implements MarkHandler {
  readonly type = 'italic';

  apply(text: string, _mark: Mark): string {
    return `*${text}*`;
  }
}
